module.exports = __webpack_public_path__ + "static/media/kilkenky.ff5909f3.png";